import userStore from '../Stores/User';
import loading from '../Assets/loading.gif';
import { observer } from 'mobx-react';
import { getPreferredVoices, putPreferredVoice } from '../audiblogsApi';
import { useEffect, useState, useRef } from 'react';
import Play from '../Components/PlayerNew/Icons/Play.svg';
import Pause from '../Components/PlayerNew/Icons/Pause.svg';
import { Redirect, useHistory } from "react-router-dom";
import { set } from 'mobx';
import { isPaidProUser, hasPaidPlan } from '../constants/plans';
import { ChevronLeft as ChevronLeftIcon } from '@mui/icons-material';
import discoverStore from './DiscoverNew/store';
import TopNavBar from '../Components/TopNavBar';
import Loader from '../Components/Loader';
import './PreferredVoices.scss';
import gamificationStore from '../Stores/GamificationStore';
import BonusIndicator from '../Components/BonusIndicator';

const PreferredVoices = observer(({ location, match }) => {
  const [preferredVoices, setPreferredVoices] = useState([]);
  const [availableVoices, setAvailableVoices] = useState([]);
  const [buttonText, setButtonText] = useState('Save');
  const [showBasicVoices, setShowBasicVoices] = useState(true);
  const [showProVoices, setShowProVoices] = useState(false);
  const [showSpanishVoices, setShowSpanishVoices] = useState(false);
  const history = useHistory();

  const audioRef = useRef(new Audio());
  const [isPlaying, setIsPlaying] = useState(false);
  const [src, setSrc] = useState('');

  const basic_voices = ["Will", "Dan", "Scarlett", "Liv", "Amy", "Zoe"];
  const pro_voices = ["Autumn", "Melody", "Hannah", "Emily", "Ivy", "Kaitlyn", "Luna", "Willow", "Lauren", "Sierra", "Noah", "Jasper", "Caleb", "Ronan", "Ethan", "Daniel", "Zane", "Rowan", "Eleanor", "Chloe", "Amelia", "Charlotte", "Benjamin", "Arthur", "Edward", "Oliver"];
  const spanish_voices = ['Elena', 'Marcelo', 'Sofia', 'Catalina', 'Lorenzo', 'Gonzalo', 'Salome', 'Juan', 'Maria', 'Manuel', 'Emilio', 'Andrea', 'Luis', 'Abril', 'Alvaro', 'Dario', 'Elias', 'Elvira', 'Estrella', 'Irene', 'Javier', 'Teresa', 'Andres', 'Marta', 'Carlos', 'Karla', 'Beatriz', 'Candela', 'Carlota', 'Cecilio', 'Jorge', 'Marina', 'Victor', 'Mario', 'Lorena', 'Rodrigo', 'Alonso', 'Mateo', 'Valentina', 'Sebastian'];
  
  // Voice metadata mapping
  const voiceMetadata = {
    // Basic voices
    "Will": { gender: "male", country: "US", flag: "🇺🇸", avatar: "👨‍💼" },
    "Dan": { gender: "male", country: "US", flag: "🇺🇸", avatar: "👨‍💻" },
    "Scarlett": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍💼" },
    "Liv": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍🎨" },
    "Amy": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍🏫" },
    "Zoe": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍🎤" },
    
    // Pro voices
    "Autumn": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍🌾" },
    "Melody": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍🎵" },
    "Hannah": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍🎓" },
    "Emily": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍⚕️" },
    "Ivy": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍🔬" },
    "Kaitlyn": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍💻" },
    "Luna": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍🎭" },
    "Willow": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍🌿" },
    "Lauren": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍🎨" },
    "Sierra": { gender: "female", country: "US", flag: "🇺🇸", avatar: "👩‍🏔️" },
    "Noah": { gender: "male", country: "US", flag: "🇺🇸", avatar: "👨‍🎓" },
    "Jasper": { gender: "male", country: "US", flag: "🇺🇸", avatar: "👨‍🎨" },
    "Caleb": { gender: "male", country: "US", flag: "🇺🇸", avatar: "👨‍💼" },
    "Ronan": { gender: "male", country: "US", flag: "🇺🇸", avatar: "👨‍🎤" },
    "Ethan": { gender: "male", country: "US", flag: "🇺🇸", avatar: "👨‍💻" },
    "Daniel": { gender: "male", country: "US", flag: "🇺🇸", avatar: "👨‍⚕️" },
    "Zane": { gender: "male", country: "US", flag: "🇺🇸", avatar: "👨‍🎭" },
    "Rowan": { gender: "male", country: "US", flag: "🇺🇸", avatar: "👨‍🌿" },
    "Eleanor": { gender: "female", country: "GB", flag: "🇬🇧", avatar: "👩‍💼" },
    "Chloe": { gender: "female", country: "GB", flag: "🇬🇧", avatar: "👩‍🎓" },
    "Amelia": { gender: "female", country: "GB", flag: "🇬🇧", avatar: "👩‍⚕️" },
    "Charlotte": { gender: "female", country: "GB", flag: "🇬🇧", avatar: "👩‍🎨" },
    "Benjamin": { gender: "male", country: "GB", flag: "🇬🇧", avatar: "👨‍💼" },
    "Arthur": { gender: "male", country: "GB", flag: "🇬🇧", avatar: "👨‍🎓" },
    "Edward": { gender: "male", country: "GB", flag: "🇬🇧", avatar: "👨‍⚕️" },
    "Oliver": { gender: "male", country: "GB", flag: "🇬🇧", avatar: "👨‍🎨" },
    
    // Spanish voices
    "Elena": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍💼" },
    "Marcelo": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍💼" },
    "Sofia": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🎓" },
    "Catalina": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🎨" },
    "Lorenzo": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🎨" },
    "Gonzalo": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍💻" },
    "Salome": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🎤" },
    "Juan": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🎓" },
    "Maria": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍⚕️" },
    "Manuel": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍⚕️" },
    "Emilio": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🎭" },
    "Andrea": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🎭" },
    "Luis": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍💼" },
    "Abril": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🌿" },
    "Alvaro": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🌿" },
    "Dario": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🎤" },
    "Elias": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🎓" },
    "Elvira": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍💻" },
    "Estrella": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🎵" },
    "Irene": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🔬" },
    "Javier": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🔬" },
    "Teresa": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🏫" },
    "Andres": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🏫" },
    "Marta": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍💼" },
    "Carlos": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍💼" },
    "Karla": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🎤" },
    "Beatriz": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🎨" },
    "Candela": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🌾" },
    "Carlota": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🎓" },
    "Cecilio": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🎨" },
    "Jorge": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍💻" },
    "Marina": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍⚕️" },
    "Victor": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍⚕️" },
    "Mario": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🎭" },
    "Lorena": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🎭" },
    "Rodrigo": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🎤" },
    "Alonso": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🏔️" },
    "Mateo": { gender: "male", country: "ES", flag: "🇪🇸", avatar: "👨‍🎓" },
    "Valentina": { gender: "female", country: "ES", flag: "🇪🇸", avatar: "👩‍🎵" },
    "Sebastian": { gender: "male", country: "ES", flag: "��🇸", avatar: "👨‍🎵" }
  };
  const isProUser = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id 
    ? isPaidProUser(userStore.user)
    : false;

  useEffect(() => {
    if (userStore.isSignedIn === false) {
      history.push('/signin?redirected_from=preferredVoices');
    }
    if (userStore.isSignedIn) {
      getPreferredVoices(userStore.idToken).then((res) => {
        const filteredPreferredVoices = isProUser 
          ? res.preferred_voices 
          : res.preferred_voices.filter(voice => !pro_voices.includes(voice) && !spanish_voices.includes(voice));
        setPreferredVoices(filteredPreferredVoices);
        setAvailableVoices(res.available_voices);
      });
    }
  }, [userStore.isSignedIn]);

  const VoiceCard = ({ localName, localeName, shortName, gender, isPro }) => {
    const handleSelection = async (e) => {
      let updatedVoices;
      if (e.target.checked) {
        updatedVoices = [...preferredVoices, shortName];
      } else {
        updatedVoices = preferredVoices.filter((voice) => voice !== shortName);
      }
      
      setPreferredVoices(updatedVoices);
      setButtonText('Saving...');
      
      try {
        await putPreferredVoice(userStore.idToken, updatedVoices);
        setButtonText('Saved!');
        
        // Note: Bonus will be awarded when user saves their voice preferences
        // This prevents the bonus from being triggered immediately on selection
        
        // Reset button text after 2 seconds
        setTimeout(() => {
          setButtonText('Save');
        }, 2000);
      } catch (error) {
        console.error('Error saving preferred voices:', error);
        setButtonText('Error - Try Again');
        // Reset button text after 3 seconds
        setTimeout(() => {
          setButtonText('Save');
        }, 3000);
      }
    }

    const handlePlayAudio = () => {
      const audio = audioRef.current;

      if (isPlaying && src.includes(shortName)) {
        audio.pause();
        setIsPlaying(false);
        return;
      } else if (isPlaying && !src.includes(shortName)) {
        audio.currentTime = 0;
        audio.pause();
        audio.src = `https://audiblogs-samples-new.s3.us-east-1.amazonaws.com/samples/${shortName}.mp3`;
        audio.play();
        setIsPlaying(true);
        setSrc(`https://audiblogs-samples-new.s3.us-east-1.amazonaws.com/samples/${shortName}.mp3`)
        return;
      } else {
        audio.src = `https://audiblogs-samples-new.s3.us-east-1.amazonaws.com/samples/${shortName}.mp3`;
        audio.play();
        setIsPlaying(true);
        setSrc(`https://audiblogs-samples-new.s3.us-east-1.amazonaws.com/samples/${shortName}.mp3`)
        return;
      }
    }

    const language = localeName.split(" (")[0];
    const locale = localeName.match(/\((.*?)\)/g)?.map(match => match.slice(1, -1));
    const isSelected = preferredVoices.includes(shortName);
    const isSelectionDisabled = isPro && !isProUser;
    const metadata = voiceMetadata[localName] || { gender: "unknown", country: "US", flag: "🇺🇸", avatar: "👤" };

    return (
      <div className={`voice-card ${isSelected ? 'selected' : ''} ${isSelectionDisabled ? 'selection-disabled' : ''}`}>
        <div className="voice-card-header">
          <div className="voice-info">
            <span className="voice-avatar">{metadata.avatar}</span>
            <div className="voice-name-container">
              <h4 className="voice-name">{localName}</h4>
              <span className="voice-flag">{metadata.flag}</span>
            </div>
          </div>
          {isPro && !isProUser && (
            <div className="pro-indicator">
              <span>PRO</span>
            </div>
          )}
        </div>
        
        <div className="voice-details">
          <span className="voice-language">{language}</span>
          <span className="voice-locale">{locale}</span>
        </div>
        
        <div className="voice-actions">
          <button 
            className="play-button"
            onClick={handlePlayAudio}
            title="Play sample"
          >
            <img 
              height="18px" 
              src={isPlaying && src.includes(shortName) ? Pause : Play} 
              alt={isPlaying && src.includes(shortName) ? "Pause" : "Play"}
            />
          </button>
          
          <label className={`checkbox-container ${isSelectionDisabled ? 'disabled' : ''}`}>
            <input
              type="checkbox"
              checked={isSelected}
              onChange={handleSelection}
              disabled={isSelectionDisabled}
            />
            <span className="checkmark"></span>
            {isSelectionDisabled && (
              <span className="upgrade-tooltip">Upgrade to Pro</span>
            )}
          </label>
        </div>
      </div>
    );
  };

  audioRef.current.addEventListener('ended', () => {
    setIsPlaying(false);
  });

  useEffect(() => {
    setButtonText('Save')
  }, [preferredVoices])

  return (
    <div className="preferred-voices-container">
      <TopNavBar />
      <button 
        onClick={() => {
          discoverStore.changeMode("addArticle");
          window.location.href = "/add";
        }}
        className="back-button"
      >
        <ChevronLeftIcon />
        <span className="back-text">Home</span>
      </button>
      
      {!userStore.isSignedIn && availableVoices.length === 0 ? (
        <Loader />
      ) : (
        <>
          <div className="preferred-voices-header">
            <h1>Preferred Voices</h1>
            <p>Choose your favorite voices for audio conversion</p>
          </div>

          <div className="preferred-voices-content">
            <div className="info-section">
              <p className="info-text">
                If you choose more than one, we'll randomize between them. While voice selection is currently available for English and Spanish, we automatically detect and convert content from <a href="https://help.audioread.com/en/articles/9854895-can-audioread-handle-non-english-languages" target="_blank" rel="noopener noreferrer">80+ languages</a> including Arabic, Chinese, French, German, Hindi, Japanese, Korean, Portuguese, Russian and more into natural-sounding audio.
                {!isProUser && <span className="upgrade-text"> Upgrade to Pro to access all languages.</span>}
              </p>
            </div>

            <div className="voices-section">
              <div className="voice-category">
                <div 
                  className="voice-category-header"
                  onClick={() => setShowBasicVoices(!showBasicVoices)}
                >
                  <h3>Basic Voices</h3>
                  <span className="expand-icon">{showBasicVoices ? '▼' : '▶'}</span>
                </div>
                
                {showBasicVoices && (
                  <div className="voice-grid">
                    {availableVoices.filter(voice => basic_voices.includes(voice.LocalName)).map((voice) =>
                      <VoiceCard 
                        key={voice.ShortName}
                        localName={voice.LocalName}
                        localeName={voice.LocaleName}
                        shortName={voice.ShortName}
                        gender={voice.Gender}
                        isPro={false}
                      />
                    )}
                  </div>
                )}
              </div>

              <div className="voice-category">
                <div 
                  className="voice-category-header"
                  onClick={() => setShowProVoices(!showProVoices)}
                >
                  <h3>Premium Voices</h3>
                  <span className="expand-icon">{showProVoices ? '▼' : '▶'}</span>
                  {!isProUser && (
                    <div className="pro-badge">
                      <span>PRO</span>
                    </div>
                  )}
                </div>
                
                {showProVoices && (
                  <div className="voice-grid">
                    {availableVoices.filter(voice => pro_voices.includes(voice.LocalName)).map((voice) =>
                      <VoiceCard 
                        key={voice.ShortName}
                        localName={voice.LocalName}
                        localeName={voice.LocaleName}
                        shortName={voice.ShortName}
                        gender={voice.Gender}
                        isPro={true}
                      />
                    )}
                  </div>
                )}
              </div>

              <div className="voice-category">
                <div 
                  className="voice-category-header"
                  onClick={() => setShowSpanishVoices(!showSpanishVoices)}
                >
                  <h3>Spanish Voices</h3>
                  <span className="expand-icon">{showSpanishVoices ? '▼' : '▶'}</span>
                  {!isProUser && (
                    <div className="pro-badge">
                      <span>PRO</span>
                    </div>
                  )}
                </div>
                
                {showSpanishVoices && (
                  <div className="voice-grid">
                    {availableVoices.filter(voice => spanish_voices.includes(voice.LocalName)).map((voice) =>
                      <VoiceCard 
                        key={voice.ShortName}
                        localName={voice.LocalName}
                        localeName={voice.LocaleName}
                        shortName={voice.ShortName}
                        gender={voice.Gender}
                        isPro={true}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="action-section">
              <BonusIndicator action={gamificationStore.actions.CHOOSE_VOICE}>
                <button
                  className="save-button"
                  disabled={buttonText === 'Saving...'}
                  onClick={() => {
                    setButtonText('Saving...');
                    putPreferredVoice(userStore.idToken, preferredVoices).then((res) => {
                      setButtonText('Saved!');
                      
                      // Award bonus characters for choosing first voice
                      if (preferredVoices.length > 0) {
                        gamificationStore.completeAction(gamificationStore.actions.CHOOSE_VOICE);
                      }
                      
                      setTimeout(() => {
                        setButtonText('Save');
                      }, 2000);
                    }).catch((error) => {
                      console.error('Error saving preferred voices:', error);
                      setButtonText('Error - Try Again');
                      setTimeout(() => {
                        setButtonText('Save');
                      }, 3000);
                    });
                  }}
                >
                  {buttonText}
                </button>
              </BonusIndicator>
            </div>
          </div>
        </>
      )}
    </div>
  );
});

export default PreferredVoices;
